import React from 'react';
import {FormControlLabel, Radio, RadioGroup, SxProps, Theme} from "@mui/material"
import {RowDataset} from "../../api/enum/RowDataset"

interface DatasetRadio {
    dataset?: RowDataset
    setDataset: (dataset: RowDataset) => void
    size?: "small" | "medium" | "large"
    sx?: SxProps<Theme>
}

function DatasetRadio({dataset, setDataset, size, sx}: DatasetRadio) {
    return (
        <RadioGroup
            row
            value={dataset}
            onChange={(_, value) => setDataset(value as RowDataset)}
        >
            <FormControlLabel value={RowDataset.TRAINING} control={<Radio/>} label="Training"/>
            <FormControlLabel value={RowDataset.VALIDATION} control={<Radio/>} label="Validation"/>
        </RadioGroup>
    );
}

export default DatasetRadio;